/* global bootstrap */

import React, { useContext, useEffect, useRef } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import moment from "moment";
import Constant from "../../Constants";

const ImportDetailsTable = ({
  data,
  columnsVisibility,
  setColumnSorts,
  columnSorts,
}) => {
  const { t } = useContext(LanguageContext);
  const { parsingProcess } = Constant();

  const tooltipInit = useRef(false);
  useEffect(() => {
    if (!tooltipInit.current && data?.length > 0) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );

      tooltipInit.current = true;
    }
  }, [data]);

  const setColumnSort = (columnIndex) => {
    setColumnSorts((prevSorts) => ({
      ...prevSorts,
      [columnIndex]:
        prevSorts[columnIndex] === "asc"
          ? "desc"
          : prevSorts[columnIndex] === "desc"
          ? null
          : "asc",
    }));
  };

  const columnsHeader = [
    { key: "input", label: t("Input") },
    { key: "parsing", label: t("Parsing") },
    { key: "processing", label: t("Processing") },
    { key: "date", label: t("Date") },
  ];

  const columnHeaderValue = {
    input: {
      value: (item) => item?.input,
      className: (item) => `text-dark`,
      style: { fontSize: "16px" },
    },
    date: {
      value: (item) =>
        `${t(moment(item?.created).format("MMM"))} ${moment(
          item?.created
        ).format("DD, YYYY")} ${t(moment(item?.created).format("A"))}`,
      className: (item) => "w-100 text-dark",
      style: { fontSize: "16px" },
    },
    parsing: {
      value: (item) => (
        <span className="d-flex gap-2 justify-content-center">
          {parsingProcess[item?.parsing]?.title}{" "}
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={parsingProcess[item?.parsing]?.title}
          >
            {parsingProcess[item?.parsing]?.icon}
          </span>
        </span>
      ),
      className: (item) => `${parsingProcess[item?.parsing]?.class} w-100`,
      style: { fontSize: "14px", fontWeight: "400", height: "29px" },
    },
    processing: {
      value: (item) => (
        <span className="d-flex gap-2 justify-content-center">
          {parsingProcess[item?.processing]?.title}{" "}
          {parsingProcess[item?.processing]?.icon}
        </span>
      ),
      className: (item) => `${parsingProcess[item?.processing]?.class} w-100`,
      style: { fontSize: "14px", fontWeight: "400", height: "29px" },
    },
  };

  return (
    <div className="table-responsive datatable-custom">
      <table
        id="datatable"
        className="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
      >
        <thead className="thead-light">
          <tr>
            {columnsHeader.map(({ key, label }, index) =>
              columnsVisibility[key] ? (
                <th
                  key={key}
                  className={`sorting${
                    !columnSorts[index]
                      ? ""
                      : columnSorts[index] === "asc"
                      ? "_asc"
                      : "_desc"
                  }`}
                  onClick={() => setColumnSort(index)}
                >
                  {t(label)}
                </th>
              ) : null
            )}
          </tr>
        </thead>
        <tbody id="nav-one-eg1" aria-labelledby="nav-one-eg1-tab">
          {!!data?.length ? (
            [...data]
              .sort((a, b) => {
                return a.input.startsWith("URL")
                  ? -1
                  : b.input.startsWith("URL")
                  ? 1
                  : 0;
              })
              .map((item, index) => (
                <tr key={index}>
                  {Object.entries(columnsVisibility)?.map(
                    ([key, isVisible]) =>
                      isVisible && (
                        <td
                          key={key}
                          style={{
                            width: key === "input" ? "auto" : "150px",
                          }}
                        >
                          <span
                            style={{
                              ...columnHeaderValue[key]?.style,
                              display: "inline-block",
                            }}
                            className={`${columnHeaderValue[key]?.className?.(
                              item
                            )}`}
                          >
                            {columnHeaderValue[key]?.value(item)}
                          </span>
                        </td>
                      )
                  )}
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan="100%">
                <div className="text-center p-4 no-data-wrapper">
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="dark"
                  />
                  <img
                    className="mb-3"
                    src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                    alt=""
                    style={{ width: "10rem" }}
                    data-hs-theme-appearance="default"
                  />
                  <p className="mb-0">
                    {!data ? t("Loading data") : t("No data to show")}
                  </p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ImportDetailsTable;
